import { Action } from '@ngrx/store';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { ISalesDocumentsRes } from '@cemex-core/cmx-api/models/sales-document-management';
import { ISalesDocument } from '@cemex-core/cmx-api/models/sales-document-management/';

export const LOAD_INITIAL_STATE = '[Anticipated Invoice] Load initial state';
export const LOAD = '[Anticipated Invoice] Load';
export const LOAD_COMPLETE = '[Anticipated Invoice] Load Complete';
export const LOAD_FAIL = '[Anticipated Invoice] Load Fail';
export const REMOVE_SELECTED_ANTICIPATED_INVOICE = '[Anticipated Invoice] Remove Selected';
export const ANTICIPATED_INVOICE_SET = '[Anticipated Invoice] Set';
export const ANTICIPATED_INVOICE_RESET = '[Anticipated Invoice] Reset';

export class AnticipatedInvoiceLoadInitialStateAction implements Action {
  readonly type = LOAD_INITIAL_STATE;

  constructor(public payload: ILocationConfigUnit) {}
}

export class AnticipatedInvoiceLoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: ISalesDocument) {}
}

export class AnticipatedInvoiceLoadCompleteAction implements Action {
  readonly type = LOAD_COMPLETE;

  constructor(public payload: ISalesDocumentsRes) {}
}

export class AnticipatedInvoiceLoadFailAction implements Action {
  readonly type = LOAD_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class AnticipatedInvoiceRemoveSelectedAction implements Action {
  readonly type = REMOVE_SELECTED_ANTICIPATED_INVOICE;

  constructor(public payload: null) {}
}

export class AnticipatedInvoiceSetAction implements Action {
  readonly type = ANTICIPATED_INVOICE_SET;

  constructor(public payload: ISalesDocument) {}
}

export class AnticipatedInvoiceResetAction implements Action {
  readonly type = ANTICIPATED_INVOICE_RESET;

  constructor() {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type AnticipatedInvoiceActions =
  | AnticipatedInvoiceLoadInitialStateAction
  | AnticipatedInvoiceLoadAction
  | AnticipatedInvoiceLoadCompleteAction
  | AnticipatedInvoiceLoadFailAction
  | AnticipatedInvoiceRemoveSelectedAction
  | AnticipatedInvoiceSetAction
  | AnticipatedInvoiceResetAction;
